module.exports = __webpack_public_path__ + "static/img/image3.959ee2b1.png";